<template>
    <div
        class="items-wrapper cursor-pointer pr-2"
        :class="{
            draggable: !flags?.readonly,
            selected: isSelected || isActiveEps,
            active: isActive,
            'print-area': isPrintArea,
            'product-guidelines': isProductGuidelines,
            overlay: isOverlay
        }"
        :style="itemStyle"
        :data-zIndex="item.zIndex"
        @click="onElementClick"
    >
        <slot />
    </div>
</template>

<script lang="ts" setup>
import type { ListElements } from '@/typings/customilyElements/layer';
import { useLayerTreeItem } from '@/components/Layers/composables/useLayerTreeItem';

const props = defineProps<{
    item: ListElements;
}>();

const {
    flags,
    isSelected,
    isActiveEps,
    isActive,
    itemStyle,
    isPrintArea,
    isProductGuidelines,
    isOverlay,
    onElementClick
} = useLayerTreeItem(props);
</script>

<style lang="scss" scoped>
.items-wrapper {
    &.print-area {
        background: repeating-linear-gradient(45deg, transparent, transparent 10px, #7157e020 10px, #7157e020 20px);
    }

    &.product-guidelines {
        background: #ede9fb;
    }

    &.overlay {
        box-shadow: inset 0px 7px 12px -10px #7157e0, inset 0px -7px 12px -10px #7157e0;
    }
}

.items-wrapper.selected .action-icon,
.items-wrapper.selected .status-icon {
    color: #fff;
}

.items-wrapper.active:not(.selected) {
    background-color: #dbe6f0 !important;
}

.action {
    text-align: center;
    width: 1.3rem;
}

.cursor-pointer {
    cursor: pointer;
}

.items-center {
    align-items: center;
}

.layer-row {
    display: flex;
    align-items: center;
    width: 100%;
}

.w-full {
    width: 100%;
}

.grow-1 {
    flex-grow: 1;
}

.shrink {
    flex-shrink: 1;
}

:deep(.layers-element-title .editable-div) {
    display: flex;
    align-items: center;
}

:deep(.layers-element-title .editable-div span:first-child) {
    padding-right: 4px;
}

.layers-element-title.not-visible {
    opacity: 0.5;
}

.draggable {
    cursor: pointer;
}
</style>
